<script>
  import { onMount } from 'svelte';
  import { getTasks } from './logic'

  let tasks

  onMount(async () => {
    tasks = await getTasks() 
  })
</script>

<!-- {JSON.stringify(tasks)} -->

{#if tasks?.msg}
  <div class="error">{tasks.msg}</div>
{:else if tasks}
<div class="table-container mt-4">
  <table class="table table-compact">
    <thead class="text-left">
      <!-- <th>Akce</th> -->
      <th>Popis</th>
      <th>Periodikum</th>
      <th>uuid</th>
      <!-- <th>Počet čísel</th> -->
      <th>Datum vytvoření</th>
      <th>Plánované</th>
      <th>Mód</th>
      <th>Datum spracování</th>
      <th>Uživatel</th>
      <th>Status</th>
      <th>Chyba</th>
    </thead>
    <tbody>
      {#each tasks as line}
        <tr>
          <!-- <td>a</td> -->
          <td>{line.description}</td>
          <td>{line.name.replaceAll(',',', ')}</td>
          <td>{line.krameriusUuid}</td>
          <!-- <td>a</td> -->
          <td>{line.createdAt}</td>
          <td>{line.timeToExecute}</td>
          <td>{line.mode}</td>
          <td>{line.processAt}</td>
          <td>{line.user}</td>
          <td>{line.status}</td>
          <td>{line.error}</td>
        </tr>
      {/each}
    </tbody>
  </table>
</div>
{/if}

